export default __webpack_public_path__ + "static/media/react.396d3bf9.png";